import { AfterContentInit, Component, ElementRef, Input, OnDestroy, inject, input, contentChild } from '@angular/core';
import { AbstractControl, FormControlDirective, FormControlName, NgModel } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { merge, NEVER, Observable } from 'rxjs';
import { UntilDestroy } from 'ngx-unificator/decorator';
import { untilDestroyed } from 'ngx-unificator/rxjs';
import { FormsErrorHandlerService } from '../../../../services/forms-error-handler.service';
import { PlatformService } from '../../../../services/platform.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { NgClass } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
    imports: [
        NgClass,
        TranslatePipe
    ]
})
export class FormInputComponent implements OnDestroy, AfterContentInit {
  private _formErrors = inject(FormsErrorHandlerService);
  private _el = inject(ElementRef);
  private _platform = inject(PlatformService);

  /**
   * Text label over input
   */
  @Input() label;

  readonly errorType = input<'tooltip' | 'bottom'>('tooltip');

  readonly radioButton = input<boolean>(null);

  @Input() additionalLabel: string;

  /**
   * List of errors for current control
   */
  @Input() errors: Array<string> = [];

  @Input() control: AbstractControl;

  readonly controlContainer = contentChild(FormControlName);
  readonly formControlContainer = contentChild(FormControlDirective);
  readonly modelContainer = contentChild(NgModel);

  readonly inputEl = contentChild('input', { read: ElementRef });

  public focus: Observable<boolean> = NEVER;

  public placeholder: any = null;

  ngAfterContentInit() {
    if (this._el.nativeElement?.querySelector('input') && this._platform.isBrowser) {
      this.placeholder = this._el.nativeElement?.querySelector('input').placeholder;
    }

    const controlContainer = this.controlContainer();
    if (!this.control && controlContainer?.control) {
      this.control = controlContainer.control;
    }

    const modelContainer = this.modelContainer();
    if (!this.control && modelContainer?.control) {
      this.control = modelContainer.control;
    }

    const formControlContainer = this.formControlContainer();
    if (!this.control && formControlContainer?.form) {
      this.control = formControlContainer?.form;
    }

    if (this.control) {
      this.errors = this._formErrors.errors(this.control);

      merge(this.control.statusChanges, this.control.valueChanges)
        .pipe(
          untilDestroyed(this),
          tap(control => {
            this.errors = this._formErrors.errors(this.control);
          }),
        )
        .subscribe();
    }
  }

  ngOnDestroy(): void {}
}
